import UserDetailPage from "./UserDetailPage";
import RegionalCompanyDetailPage from "./RegionalCompanyDetailPage";

export default class RegionalCompanyUserDetailPage extends UserDetailPage {
  static PageInfo = {
    
    hidden:true,
    parent: RegionalCompanyDetailPage,
    path: "/Admin/StateGroup/:state/Company/:id/User/:target",
    name: "menu.user",
    access: { 1: true },
    permission: { "CONFIGURATION_USERS_ACCESSING": true },
    icon: "user"
  }
}  